import { FC } from "react";

interface IAppLink {
    link: string;
    title: string;
}

export const AppLink: FC<IAppLink> = ({link, title}) => <a target="__blank" href={link}>{title}</a>